import { Star, Quote } from "lucide-react";
import { Reveal, MaskLine, SectionLabel } from "./Reveal";
import { BRAND, REVIEWS } from "../data/site";

const Card = ({ r }) => (
  <figure className="group steel-panel grain relative flex w-[290px] shrink-0 flex-col justify-between overflow-hidden p-6 transition-colors duration-500 hover:border-[#c5a059]/45 sm:w-[360px]">
    <Quote
      size={26}
      className="mb-5 text-[#c5a059]/45 transition-colors duration-500 group-hover:text-[#c5a059]"
    />
    <blockquote className="text-sm leading-relaxed text-slate-300">
      "{r.quote}"
    </blockquote>
    <figcaption className="mt-7 border-t border-white/[0.08] pt-4">
      <p className="font-cond text-base font-bold uppercase tracking-[0.1em] text-[#f0e9dc]">
        {r.name}
      </p>
      <div className="mt-2 flex items-center gap-2">
        <span className="flex gap-0.5">
          {[...Array(5)].map((_, i) => (
            <Star key={i} size={9} className="fill-[#c5a059] text-[#c5a059]" />
          ))}
        </span>
        <span className="text-[10px] uppercase tracking-[0.18em] text-slate-500">
          {r.src}
        </span>
      </div>
    </figcaption>
  </figure>
);

export const Reviews = () => {
  const track = [...REVIEWS, ...REVIEWS];

  return (
    <section
      id="reviews"
      data-testid="testimonials-section"
      className="relative overflow-hidden bg-[#0a0d12] py-24 lg:py-36"
    >
      <div className="mx-auto max-w-[1400px] px-5 lg:px-10">
        <div className="flex flex-col gap-8 lg:flex-row lg:items-end lg:justify-between">
          <div>
            <SectionLabel testId="reviews-label">
              Chapter 05 · The Receipts
            </SectionLabel>
            <h2 className="mt-7 font-cond text-4xl font-extrabold uppercase leading-[0.92] sm:text-5xl lg:text-6xl">
              <MaskLine>Argyle &amp; Lantana</MaskLine>
              <MaskLine delay={0.1} className="brass-text">
                already decided.
              </MaskLine>
            </h2>
          </div>
          <Reveal delay={0.15}>
            <div
              data-testid="google-rating-badge"
              className="steel-panel flex items-center gap-5 p-5"
            >
              <div>
                <p className="font-cond text-5xl font-extrabold leading-none text-[#c5a059]">
                  {BRAND.rating}
                </p>
                <div className="mt-2 flex gap-0.5">
                  {[...Array(5)].map((_, i) => (
                    <Star
                      key={i}
                      size={11}
                      className="fill-[#c5a059] text-[#c5a059]"
                    />
                  ))}
                </div>
              </div>
              <div className="h-14 w-px bg-white/10" />
              <p className="max-w-[130px] text-[11px] uppercase leading-snug tracking-[0.14em] text-slate-400">
                {BRAND.reviewCount}+ verified Google reviews
              </p>
            </div>
          </Reveal>
        </div>
      </div>

      {/* continuous right-to-left carousel with fade-in / fade-out edges */}
      <Reveal delay={0.1}>
        <div
          data-testid="reviews-carousel"
          className="marquee-host mask-fade-x relative mt-14 overflow-hidden"
        >
          <div className="animate-marquee flex w-max items-stretch gap-4">
            {[...track, ...track].map((r, i) => (
              <Card key={`${r.name}-${i}`} r={r} />
            ))}
          </div>
        </div>
      </Reveal>

      <p className="mx-auto mt-8 max-w-[1400px] px-5 text-[11px] uppercase tracking-[0.18em] text-slate-400 lg:px-10">
        Hover to pause · Pulled from our Google profile
      </p>
    </section>
  );
};
